













import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'ListJiko',
  components: {
    CtrlSearchCommonComponents,
  },
  props: {
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    headers: [
      {
        text: 'コード',
        sortable: true,
        value: 'jikoCd',
        width: 17,
      },
      {
        text: '名称',
        sortable: true,
        value: 'jikoNaiyo',
        width: 85,
      },
    ],
    formatColName: 'jikoCd',
  }),
});
